import { Box, Tabs, Tab, Typography } from "@mui/material";
import React, { useState } from "react";
import SideNavbar from "../../../components/sideNavbar";
import Header from "../../../components/header";
import IntegrationsHubMUI from "./IntegrationsHubMUI";

const Integrations = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  

  return (
    <div>
      <Box>
        <Box sx={{ ml: { xs: "0px", md: "280px" } }}>
          <SideNavbar />
          <Box sx={{ display: { xs: "none", md: "initial" } }}>
            <Header title={"Integrations"} />
          </Box>

          <Box component="main" sx={{ flexGrow: 0 }}>
            <IntegrationsHubMUI />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Integrations;
